import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AlertDialogModule } from '@portal-core/general/components/alert-dialog/alert-dialog.module';
import { DimensionPickerModule } from '@portal-core/general/components/dimension-picker/dimension-picker.module';
import { CssStyleListModule } from '@portal-core/project-files/components/css-style-list.component/css-style-list.module';
import { FlareFileTextEditorFeatureUnsupportedDialogModule } from '@portal-core/project-files/components/flare-file-text-editor-feature-unsupported-dialog/flare-file-text-editor-feature-unsupported-dialog.module';
import { LinkPropertiesDialogModule } from '@portal-core/project-files/components/link-properties-dialog/link-properties-dialog.module';
import { MultimediaDialogModule } from '@portal-core/project-files/components/multimedia-dialog/multimedia-dialog.module';
import { ProjectFilesImageDialogModule } from '@portal-core/project-files/components/project-files-image-dialog/project-files-image-dialog.module';
import { ProjectFilesProxyDialogModule } from '@portal-core/project-files/components/project-files-proxy-dialog/project-files-proxy-dialog.module';
import { ApplyConditionsDialogModule } from '@portal-core/project-files/conditions/components/apply-conditions-dialog/apply-conditions-dialog.module';
import { InsertVariableDialogModule } from '@portal-core/project-files/variables/components/insert-variable-dialog/insert-variable-dialog.module';
import { EditorToolbarModule } from '@portal-core/ui/editor/components/editor-toolbar/editor-toolbar.module';
import { FlareFileTextEditorToolbarComponent } from './flare-file-text-editor-toolbar.component';

@NgModule({
  declarations: [
    FlareFileTextEditorToolbarComponent
  ],
  imports: [
    AlertDialogModule,
    CommonModule,
    CssStyleListModule,
    DimensionPickerModule,
    FlareFileTextEditorFeatureUnsupportedDialogModule,
    ProjectFilesImageDialogModule,
    ProjectFilesProxyDialogModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    EditorToolbarModule,
    InsertVariableDialogModule,
    LinkPropertiesDialogModule,
    ApplyConditionsDialogModule,
    MultimediaDialogModule
  ],
  exports: [
    FlareFileTextEditorToolbarComponent
  ]
})
export class FlareFileTextEditorToolbarModule { }
